import type { SVGProps } from 'react';
import * as React from 'react';

export const Close = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.899 2.768a.8.8 0 1 0-1.131 1.13L6.868 8l-4.1 4.1a.8.8 0 1 0 1.13 1.132L8 9.132l4.1 4.1a.8.8 0 1 0 1.132-1.131L9.132 8l4.1-4.101a.8.8 0 0 0-1.131-1.131L8 6.868l-4.101-4.1Z"
      clipRule="evenodd"
    />
  </svg>
);
